"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormIds = void 0;
var FormIds;
exports.FormIds = FormIds;
(function (FormIds) {
  FormIds[FormIds["CashbackLanding"] = 211] = "CashbackLanding";
  FormIds[FormIds["CashbackLandingGazprom"] = 241] = "CashbackLandingGazprom";
  FormIds[FormIds["CashbackLandingAkBars"] = 249] = "CashbackLandingAkBars";
  FormIds[FormIds["Cashback"] = 212] = "Cashback";
  FormIds[FormIds["InvestCashback"] = 304] = "InvestCashback";
  FormIds[FormIds["PhoneNumber"] = 227] = "PhoneNumber";
  FormIds[FormIds["BusinessCredit"] = 228] = "BusinessCredit";
  FormIds[FormIds["BusinessRKO"] = 231] = "BusinessRKO";
  FormIds[FormIds["BusinessRkoFreeDialog"] = 231] = "BusinessRkoFreeDialog";
  FormIds[FormIds["BusinessRkoBlock"] = 354] = "BusinessRkoBlock";
  FormIds[FormIds["BusinessVed"] = 291] = "BusinessVed";
  FormIds[FormIds["BusinessAcquiring"] = 233] = "BusinessAcquiring";
  FormIds[FormIds["BusinessAccounting"] = 258] = "BusinessAccounting";
  FormIds[FormIds["BankGuarantees"] = 232] = "BankGuarantees";
  FormIds[FormIds["CourseSelectionGoing"] = 236] = "CourseSelectionGoing";
  FormIds[FormIds["CourseSelectionSend"] = 236] = "CourseSelectionSend";
  FormIds[FormIds["BusinessLoansApiRequest"] = 253] = "BusinessLoansApiRequest";
  FormIds[FormIds["BusinessRegistration"] = 242] = "BusinessRegistration";
  FormIds[FormIds["BusinessMarketplace"] = 259] = "BusinessMarketplace";
  FormIds[FormIds["ApiRequest"] = 260] = "ApiRequest";
  FormIds[FormIds["ProjectApiAgents"] = 300] = "ProjectApiAgents";
  FormIds[FormIds["KubanCreditBankRKO"] = 355] = "KubanCreditBankRKO";
  FormIds[FormIds["DmsVsk"] = 370] = "DmsVsk";
  FormIds[FormIds["KubanCreditBankBusinessRegistration"] = 356] = "KubanCreditBankBusinessRegistration";
  FormIds[FormIds["KubanCreditBankVED"] = 357] = "KubanCreditBankVED";
  FormIds[FormIds["Bankruptcy"] = 264] = "Bankruptcy";
  FormIds[FormIds["ApiBankruptcy"] = 278] = "ApiBankruptcy";
  FormIds[FormIds["BankruptcyDialog"] = 279] = "BankruptcyDialog";
  FormIds[FormIds["LeasingApiRequest"] = 274] = "LeasingApiRequest";
  FormIds[FormIds["LeasingApiRequestVtb"] = 398] = "LeasingApiRequestVtb";
  FormIds[FormIds["ApiAcquiring"] = 283] = "ApiAcquiring";
  FormIds[FormIds["BusinessLeasing"] = 287] = "BusinessLeasing";
  FormIds[FormIds["BusinessLeasingBlock"] = 330] = "BusinessLeasingBlock";
  FormIds[FormIds["LeasingRequestSending"] = 294] = "LeasingRequestSending";
  FormIds[FormIds["ApiBusinessRegistration"] = 296] = "ApiBusinessRegistration";
  FormIds[FormIds["AccountingForAC"] = 299] = "AccountingForAC";
  FormIds[FormIds["ApiAccountingServices"] = 301] = "ApiAccountingServices";
  FormIds[FormIds["NNPFLanding"] = 302] = "NNPFLanding";
  FormIds[FormIds["AutoLeasing"] = 308] = "AutoLeasing";
  FormIds[FormIds["SalaryProject"] = 309] = "SalaryProject";
  FormIds[FormIds["BusinessDeposit"] = 234] = "BusinessDeposit";
  FormIds[FormIds["ApiApplicationRosAgroLeasing"] = 334] = "ApiApplicationRosAgroLeasing";
  FormIds[FormIds["BusinessCreditSberFactoring"] = 345] = "BusinessCreditSberFactoring";
  FormIds[FormIds["BookmakerFormID"] = 360] = "BookmakerFormID";
  FormIds[FormIds["rkoRSHBAgents"] = 205] = "rkoRSHBAgents";
  FormIds[FormIds["redGate"] = 371] = "redGate";
  FormIds[FormIds["KSKFactoring"] = 368] = "KSKFactoring";
  FormIds[FormIds["KubanCreditBank"] = 369] = "KubanCreditBank";
  FormIds[FormIds["InternetProviderBlock"] = 392] = "InternetProviderBlock";
  FormIds[FormIds["HomeInternetApplication"] = 394] = "HomeInternetApplication";
  FormIds[FormIds["RKOBusinessRegistration"] = 396] = "RKOBusinessRegistration";
  FormIds[FormIds["CreditEuropeBankAcquiring"] = 405] = "CreditEuropeBankAcquiring";
  FormIds[FormIds["DmsRenaissance"] = 407] = "DmsRenaissance";
  FormIds[FormIds["MetallinvestbankCreditForBusiness"] = 409] = "MetallinvestbankCreditForBusiness";
})(FormIds || (exports.FormIds = FormIds = {}));